export const IFRAME_SANDBOX = 'allow-scripts allow-forms allow-popups';

export const IFRAME_REFERRER_POLICY = 'no-referrer';

export const IFRAME_SECTION_MESSAGES = {
  UNTITLED_SECTION: 'Untitled section',
  MISSING_URL: 'This embed has no URL configured.',
};
